import {ChangeDetectorRef, Directive, ElementRef, HostListener, Input} from "@angular/core";
import {FUIAbstractInput} from "../../framework/abstract-input";

@Directive()
export abstract class FUIAbstractTextInput extends FUIAbstractInput {
    @Input() public readonly: boolean;

    constructor(public elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    override click(): void {
        this.focus();
    }

    protected override determineValued(value: any): void {
        this.valued = !!value;
    }
}
